import { createContext, useContext } from 'react';

import { PageLayoutProps, PageLayoutWidth } from './PageLayout.types';

const PageLayoutPrivateContext = createContext<PageLayoutPrivateContextProps>({});

export default PageLayoutPrivateContext;

export interface PageLayoutPrivateContextProps
  extends Pick<
    PageLayoutProps,
    | 'closeContentSidebarAriaLabel'
    | 'collapseLeftSidebar'
    | 'noScroll'
    | 'noSpacing'
    | 'onRenderSubHeader'
    | 'showContentSidebarAriaLabel'
    | 'suppressTopPadding'
    | 'fullWidthLayout'
  > {
  readonly hasBanner?: boolean;
  readonly hasHeader?: boolean;
  readonly hasLeftSidebar?: boolean;
  readonly showLeftSidebar?: boolean;
  readonly showSubHeader?: boolean;
  readonly topOffset?: number;
  readonly width?: PageLayoutWidth;
  readonly hasFooter?: boolean;
}

export type UsePageLayoutPrivateContext = () => PageLayoutPrivateContextProps;
export const usePageLayoutPrivateContext: UsePageLayoutPrivateContext = () =>
  useContext<PageLayoutPrivateContextProps>(PageLayoutPrivateContext);
